class CartModal extends HTMLElement {
  constructor() {
    super();

    this.modal = this;
    this.continueBtn = this.modal.querySelector(
      '#addedProductModal-continue-btn',
    );

    this.continueBtn.addEventListener('click', () => {
      this.close();
      // keep modal visible briefly, then reload to update cart contents
      setTimeout(() => {
        location.reload();
      }, 350);
    });
    // this.onBodyClick = this.handleBodyClick.bind(this);
  }

  open() {
    this.modal.style.display = 'flex';
    setTimeout(() => {
      this.modal.classList.add('active');
    }, 10);
    document.body.style.overflow = 'hidden';
  }

  close() {
    setTimeout(() => {
      this.modal.classList.remove('active');
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
    }, 350);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    const countElement = this.modal.querySelector('#new-product-count');
    const pluralElement = this.modal.querySelector('#product-pluralized');
    const parsedQuantity = parseInt(parsedState._addedQuantity, 10);
    const quantity =
      Number.isFinite(parsedQuantity) && parsedQuantity > 0
        ? parsedQuantity
        : 1;
    if (countElement) countElement.textContent = quantity;
    if (pluralElement)
      pluralElement.textContent = quantity === 1 ? 'product' : 'products';

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-product-quantity',
        selector: `[id="cart-product-quantity-${this.cartItemKey}"]`,
      },
    ];
  }

  handleBodyClick(event) {
    if (!this.modal.contains(event.target)) {
      this.close();
    }
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-modal', CartModal);
